import script from "./ConnectCellSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectCellSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ConnectCellSkeleton.vue?vue&type=style&index=0&id=4d670aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d670aa4"]])

export default __exports__